import { RiDashboardLine } from 'react-icons/ri';
import { AiOutlineTool } from 'react-icons/ai';
import { FiSettings } from 'react-icons/fi';
import { GiMagicLamp, GiUnicorn } from 'react-icons/gi';
import { BsChatLeftDots } from 'react-icons/bs';

const dashRoutes = [
  {
    path: '/dashboard',
    name: 'ダッシュボード',
    icon: <RiDashboardLine color="inherit" />,
    state: 'pageCollapse',
    className: 'tour-menu-to-dashboard',
    spClassName: 'tour-menu-to-dashboard-sp',
  },
  {
    path: '/chat',
    name: 'Catchy Chat(α版)',
    icon: <BsChatLeftDots color="inherit" />,
  },
  {
    path: '/tools',
    name: '生成ツール',
    icon: <AiOutlineTool color="inherit" />,
    nested: true,
    className: 'tour-menu-to-tools',
    spClassName: 'tour-menu-to-tools-sp',
  },
  {
    path: '/magics/article',
    name: '記事制作',
    icon: <GiMagicLamp color="inherit" />,
  },
  {
    path: '/magics/youtube',
    name: 'YouTube企画',
    icon: <GiMagicLamp color="inherit" />,
  },
  {
    path: '/magics/business-plan',
    name: '事業計画',
    icon: <GiUnicorn color="inherit" />,
  },
  {
    path: '/magics/press-release',
    name: 'プレスリリース',
    icon: <GiMagicLamp color="inherit" />,
  },
  {
    path: '/settings/billing',
    name: '設定',
    icon: <FiSettings color="inherit" />,
  },
];
export default dashRoutes;
